// A diagramok sorozat-színei. Az első kettő szándékosan eltérő árnyalat (lila /
// ibolyáskék), hogy egymás mellett is szét lehessen szedni őket.
export const CHART_COLORS = ['#ae76de', '#8f7cf5', '#8f52c9', '#553cd0'];

// Egy helyen a recharts sötét témája — így nem csúszik el tabonként.
export const CHART_THEME = {
  grid: 'rgba(255,255,255,0.06)',
  axis: '#5c566e',
  tooltip: {
    backgroundColor: 'rgba(20,17,28,0.96)',
    border: '1px solid rgba(255,255,255,0.09)',
    borderRadius: 10,
    fontSize: 13,
    boxShadow: '0 20px 40px -16px rgba(0,0,0,0.9)',
  },
  tooltipLabel: { color: '#d8d5e1', fontWeight: 600, marginBottom: 4 },
};

export const ANN_TYPES = [
  { id: 'announcement', label: 'Announcement', tone: 'sky' },
  { id: 'update',       label: 'Update',       tone: 'brand' },
  { id: 'maintenance',  label: 'Maintenance',  tone: 'amber' },
];

export const ACTION_LABELS = {
  'auth.register':              'Registration',
  'auth.logout':                'Logout',
  'user.change_password':       'Password Changed',
  'user.change_password_failed':'Password Change Failed',
  'key.activate':               'Key Activated',
  'key.activate_failed':        'Key Activation Failed',
  'key.generate':               'Key Generated',
  'key.delete':                 'Key Deleted',
  'user.ban':                   'User Banned',
  'user.auto_ban':              'Auto Banned (Detection)',
  'user.unban':                 'User Unbanned',
  'user.reset_hwid':            'HWID Reset',
  'user.role_give_admin':       'Admin Granted',
  'user.role_remove_admin':     'Admin Removed',
  'user.role_give_tester':      'Tester Granted',
  'user.role_remove_tester':    'Tester Removed',
  'subscription.extend_user':   'Days Added To User',
  'owner.extend_subscriptions': 'Days Added To Everyone',
  'subscription.freeze':        'Subscription Frozen',
  'subscription.unfreeze':      'Subscription Unfrozen',
  'owner.global_freeze':        'Global Freeze',
  'owner.global_unfreeze':      'Global Unfreeze',
  'system.set_site_status':     'Site Status Changed',
  'system.toggle_invite_system':'Invite System Toggled',
  'invite.request_submit':      'Invite Requested',
  'invite.request_approve':     'Invite Approved',
  'invite.request_reject':      'Invite Rejected',
  'announcement.create':        'Announcement Created',
  'announcement.update':        'Announcement Updated',
  'announcement.delete':        'Announcement Deleted',
  'catalog.product_create':     'Product Created',
  'catalog.product_update':     'Product Updated',
  'catalog.product_delete':     'Product Deleted',
  'catalog.plan_create':        'Plan Created',
  'catalog.plan_update':        'Plan Updated',
  'catalog.plan_delete':        'Plan Deleted',
  'catalog.card_fee_update':    'Card Fee Changed',
  'catalog.whop_secret_reveal': 'Whop Secret Revealed',
  'user.leaderboard_opt_in':    'Leaderboard Visibility Changed',
  'invite.owner_generate':      'Invite Code Generated',
  'invite.delete':              'Invite Code Deleted',
};

export function actionColor(action) {
  if (
    action.includes('failed') ||
    action.includes('blocked') ||
    action === 'user.ban' ||
    action === 'user.role_remove_admin' ||
    action === 'user.role_remove_tester' ||
    action === 'invite.request_reject'
  ) return 'bg-red-500/12 text-red-300 border-red-500/25';

  if (action.includes('freeze') && !action.includes('unfreeze'))
    return 'bg-sky-500/12 text-sky-300 border-sky-500/25';

  if (['user.unban', 'subscription.unfreeze', 'owner.global_unfreeze', 'invite.request_approve', 'user.role_give_admin', 'user.role_give_tester'].includes(action))
    return 'bg-emerald-500/12 text-emerald-300 border-emerald-500/25';

  if (action.startsWith('auth.'))
    return 'bg-white/[0.05] text-gray-400 border-white/[0.08]';

  return 'bg-brand-500/12 text-brand-200 border-brand-400/25';
}
